import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { AppButton } from '../../app/common/ui'
import { IoCheckmark } from 'react-icons/io5'
import { useHistory } from 'react-router-dom'
import { useStore } from '../../app/stores/store'

interface Props {
  firearmModelId: string;
}

export default observer(function AddToVaultButton ({ firearmModelId }: Props) {
  const { gunVaultStore, userStore } = useStore()
  const history = useHistory()
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (userStore.isLoggedIn && gunVaultStore.items.length === 0 && !gunVaultStore.loading) {
      gunVaultStore.loadVault()
    }
  }, [userStore.isLoggedIn, gunVaultStore])

  if (!userStore.isLoggedIn) {
    return (
      <AppButton
        size="sm"
        variant="outline"
        color="gray"
        onClick={() => history.push('/register')}
        sx={{ minWidth: 130 }}
      >
        Add to Vault
      </AppButton>
    )
  }

  const inVault = gunVaultStore.isInVault(firearmModelId)

  const handleClick = async () => {
    if (inVault) return
    setBusy(true)
    try {
      await gunVaultStore.addFirearm(firearmModelId)
    } finally {
      setBusy(false)
    }
  }

  return (
    <AppButton
      size="sm"
      variant={inVault ? 'light' : 'outline'}
      color={inVault ? 'green' : 'gray'}
      leftIcon={inVault ? <IoCheckmark size={14} /> : undefined}
      loading={busy}
      onClick={handleClick}
      disabled={inVault}
      sx={{ minWidth: 130 }}
    >
      {inVault ? 'In Vault ✓' : 'Add to Vault'}
    </AppButton>
  )
})
